import apiClient from '../../../shared/api/client';

export const getUsers = async () => {
  const { data } = await apiClient.get('/users');
  return data;
};

export const getUserById = async (userId) => {
  const { data } = await apiClient.get(`/users/${userId}`);
  return data;
};

export const updateUser = async ({ userId, payload }) => {
  const { data } = await apiClient.put(`/users/${userId}`, payload);
  return data;
};

export const registerUser = async (payload) => {
  const { data } = await apiClient.post('/users/admin/register', payload);
  return data;
};

export const deactivateUser = async (userId) => {
  const { data } = await apiClient.put(`/users/delete/${userId}`);
  return data;
};

export const activateUser = async (userId) => {
  const { data } = await apiClient.put(`/users/activate/${userId}`);
  return data;
};
